import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { EmptyState } from '@/components/ui';

export default function NotFound() {
  return (
    <div className="page"><EmptyState icon={<Compass />} title="This page doesn't exist" action={<Link className="btn btn-primary" to="/">Go to your workspace</Link>}>
      The link may be out of date, or you may not have access to it.
    </EmptyState></div>
  );
}
